@if (data) {
  <div class="d-flex align-items-center justify-content-center flex-wrap gap-8">
    <button class="btn eod-btn-outline-primary f-11" (click)="onUserAction(viewDetailAction)">
      {{ "view_detail" | translate: param }}
    </button>
    @if (data?.goToXeroLink != null && data.goToXeroLink.includes('go.xero.com')) {
      <button class="btn ml-1 btn-primary f-11" (click)="onUserAction(xeroAction)">
        {{ "go_to_xero" | translate: param }}
      </button>
    }
    @if (data?.goToXeroLink != null && data.goToXeroLink.includes('qbo.intuit.com')) {
      <button class="btn ml-1 btn-primary f-11" (click)="onUserAction(quickBooksAction)">
        {{ "go_to_quickbooks" | translate: param }}
      </button>
    }
  </div>
}
